angular.module('app').controller('PspaCtrl', function($controller, $scope, $http, $mdDialog, appUtils, PhotoUtils, $mdToast, $rootScope) {
    "ngInject";

    var main = this;
    main.name = 'event';
    main.photoUtils = PhotoUtils;
    main.downloadType = 'Selected';
    main.downloadColumns = 'default';
    main.includeEmpty = '0';
    main.includeHeaders = '0';
    main.show_with_photos = "all";
    main.show_with_selection = "all";

    main.defaultColumns = [
        {'id': 'id', 'label': 'EZ-Go Signup Id #', 'on': false},
        {'id': 'volume-name', 'label': 'Volume Name', 'on': true},
        {'id': 'image-folder', 'label': 'Image Folder', 'on': true},
        {'id': 'image-file-name', 'label': 'Image File Name', 'on': true},
        {'id': 'grade', 'label': 'Grade', 'on': true},
        {'id': 'last-name', 'label': 'Last Name', 'on': true},
        {'id': 'first-name', 'label': 'First Name', 'on': true},
        {'id': 'homeroom', 'label': 'Home room', 'on': true},
        {'id': 'period', 'label': 'Period', 'on': true},
        {'id': 'teacher-name', 'label': 'Teacher Name', 'on': true},
        {'id': 'id-number', 'label': 'ID Number', 'on': false},
    ];
    
    main.columns = [];


    main.loadSubjects = function() {
        $http.get('/api/v1/admin/event_signup?page=1&results_per_page=10000&is_list=1&includePhotos=1&q={"filters":[{"name":"event_id","op":"eq","val":"'+ main.id +'"}],"order_by":[{"field":"last_name","direction":"asc"}]}').then(
            function(response) {
                main.subjects = response.data.objects;
                main.subjects.forEach(main.findSelection);
            }
        );
    }

    main.addExtraColumns = function() {
        main.columns = angular.copy(main.defaultColumns);
        main.item.event_question_relationships.forEach((qr) => {
            if(qr.question.id == 1 || qr.question.id == 2) {
                return true;
            }

            main.columns.push({
                'id': `answer-${qr.question.id}`,
                'label': qr.question.name,
                'on': false
            });
        });
    }

    $scope.$on('model-loaded', main.loadSubjects);
    $scope.$on('model-loaded', main.addExtraColumns);
    $rootScope.$on('yearbook-updated', main.loadSubjects);

    main.openPhotos = function(signup) {
        var dia = appUtils.quickDialog('ManagePhotosCtrl', 'manage-photos-dialog.html', {
            'id': signup.id,
            'showMakeSelection': true,
            'embedded': true
        });
    }

    main.findSelection = function(item) {
        item.photos.forEach(function(photo) {
            if(photo.yearbook_selection) {
                item.selection = photo;
                item.explicit_yearbook_selection = true;
                item.selection.preview_url = item.selection.preview_url.replace('width=100', 'width=400');
                return false;
            }

            if(photo.yearbook_candidate && !item.selection) {
                item.selection = photo;
                item.explicit_yearbook_selection = false;
                item.selection.preview_url = item.selection.preview_url.replace('width=100', 'width=400');
                return false;
            }
        });
    }

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.save = function() {
        var data = {
            'downloadType': main.downloadType,
            'includeHeaders': main.includeHeaders,
            'includeEmpty': main.includeEmpty,
            'columns': main.downloadColumns == 'default' ? main.defaultColumns : main.columns
        }
        $http({'method': 'POST', 'url': '/api/v1/admin/event/' + main.id + '/pspa', 'data': data}).then(
            function(response) {
                appUtils.fileReaderDownload('text/csv', 'INDEX.txt', response.data);
            }
        );
        $mdDialog.hide();
    }


});
